import { UserService } from '../../shared/services/user.service';
import { Component, inject } from '@angular/core';
import { User } from '../../core/declarations/user.interface';
import { Paginated } from '../../core/declarations/paginated.interface';
import {
  BehaviorSubject,
  debounceTime,
  distinctUntilChanged,
  Observable,
  switchMap
} from 'rxjs';
import { Fetchable } from '../../core/declarations/fetchable.interface';
import {
  ModalAbstractComponent,
  SelectModalBaseComponent
} from '@bling-fe/shared/modals/base-modal';
import { SelectOption } from '../../shared/components/forms/select/select.component';
import { TranslateModule } from '@ngx-translate/core';
import { IonicModule } from '@ionic/angular';
import { NgFor } from '@angular/common';
import { AvatarComponent } from '../../shared/components/avatar/avatar.component';
import { UiInfinitePaginationModule } from '@bling-fe/shared/ui-components/ui-infinite-pagination';

@Component({
  selector: 'fl-select-user-modal',
  templateUrl: './select-user-modal.component.html',
  styleUrls: ['./select-user-modal.component.scss'],
  imports: [
    TranslateModule,
    IonicModule,
    SelectModalBaseComponent,
    NgFor,
    UiInfinitePaginationModule,
    AvatarComponent
  ]
})
export class SelectUserModalComponent extends ModalAbstractComponent<
  { value: User },
  SelectOption<User>
> {
  private userService = inject(UserService);
  users$: Observable<Fetchable<Paginated<User>>> = this.userService.data$;
  public searchFilter = new BehaviorSubject<string>('');

  ionViewWillEnter() {
    this.searchFilter
      .pipe(
        debounceTime(100),
        distinctUntilChanged(),
        switchMap(term =>
          this.userService.fetch({
            q: term
          })
        )
      )
      .subscribe();
  }

  fetchNextPage() {
    this.userService.fetchNextPage();
  }

  async doRefresh(e) {
    await this.userService.refetch();
    e.complete();
  }
}
